import { NextPageContext } from 'next';

import { FBPixelEventInfo } from '../types';

export const getFacebookEventsProps = (
  ctx: NextPageContext
): FBPixelEventInfo => {
  const { paymentType, subscriptionCadence, subscriptionProgram } = ctx.query;

  return {
    paymentType: paymentType as string,
    subscriptionCadence: subscriptionCadence as string,
    subscriptionProgram: subscriptionProgram as string,
  };
};
